import { Share } from './Share';
import shareIcon from '@/assets/share.svg';
import Image from 'next/image';

interface ShareButtonProps {
  folder?: {
    id: number;
    name: string;
    reports?: any[];
  };
  report?: {
    id: string;
    name: string;
  };
  className?: string;
}

export function ShareButton({ folder, report, className = '' }: ShareButtonProps) {
  return (
    <Share folder={folder} report={report}>
      <button
        className={`inline-flex items-center space-x-2 rounded bg-blue-600 px-3 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none ${className}`}
        title="Share"
      >
        <Image src={shareIcon} alt="share" width={16} height={16} />
        <span>Share</span>
      </button>
    </Share>
  );
}